// Types
import { Icon as IconType } from '../../../types/icon';
import { Measurements } from '../../../types/measurements';

// Utils
import { getMeasurementBySize } from '../../../utils/icon';

// Component
import Icon from '../Icon/Icon';

const IconSwitcher = (props: IconType) => {
  const {
    size,
    inverse,
    onClick,
    width,
    height,
    iconClassName,
  } = props;

  const defaultMeasurements: Measurements = {
    height: 9,
    width: 16,
  }

  const measurements = size ? getMeasurementBySize(size) : defaultMeasurements;

  return (
    <Icon inverse={inverse} onClick={onClick} className={iconClassName} classNameIconType="c-icon-switcher">
      <svg
        className="c-icon-switcher fill-current"
        width={width || measurements.width}
        height={height || measurements.height}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0ZM9.99248 7.9979C9.99248 9.10128 9.09802 9.99574 7.99465 9.99574C6.89127 9.99574 5.99681 9.10128 5.99681 7.9979C5.99681 6.89452 6.89127 6.00006 7.99465 6.00006C9.09802 6.00006 9.99248 6.89452 9.99248 7.9979ZM8 13.9948C4.68917 13.9948 2.00521 11.3108 2.00521 8C2.00521 5.56372 3.45852 3.4669 5.54548 2.52914C5.58344 2.51208 5.6216 2.4954 5.65998 2.47911C5.76709 2.44011 5.88271 2.41881 6.0033 2.41881C6.55741 2.41881 7.00661 2.86801 7.00661 3.42212C7.00661 3.79941 6.79831 4.128 6.49048 4.29933C6.43127 4.3235 6.37278 4.34908 6.31503 4.37597C4.95032 5.01157 4.00435 6.3953 4.00435 8C4.00435 10.2067 5.79326 11.9957 8 11.9957C10.2067 11.9957 11.9957 10.2067 11.9957 8C11.9957 6.39208 11.0458 5.00603 9.67672 4.37218C9.62587 4.34864 9.57445 4.32614 9.52248 4.3047C9.20934 4.13492 8.9967 3.80335 8.9967 3.42211C8.9967 2.868 9.44589 2.41881 10 2.41881C10.1132 2.41881 10.2219 2.43756 10.3234 2.47209C10.3751 2.49387 10.4265 2.51634 10.4775 2.53952C12.5521 3.48231 13.9948 5.57267 13.9948 8C13.9948 11.3108 11.3108 13.9948 8 13.9948Z" />
      </svg>
    </Icon>
  );
};

export default IconSwitcher;
